const OrkneyIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_112097)">
      <path
        d="M39.311 25.2175C39.7594 23.5539 40 21.8053 40 20.0001C40 18.1948 39.7594 16.4462 39.311 14.7827L18.2609 0.0761719C14.353 0.412891 10.7668 1.87305 7.82609 4.1325L0.688984 14.7827C0.240625 16.4462 0 18.1948 0 20.0001C0 21.7948 0.237734 23.5338 0.681094 25.1886L7.82602 35.8677C10.7667 38.1271 14.3529 39.5873 18.2608 39.924L39.311 25.2175Z"
        fill="#FFDA44"
      />
      <path
        d="M0.688965 25.2168C1.84615 29.5105 4.39662 33.2319 7.82607 35.867V25.2168H0.688965Z"
        fill="#D80027"
      />
      <path
        d="M18.2607 39.9233C18.834 39.9727 19.4138 39.9994 19.9999 39.9994C29.2404 39.9994 37.0159 33.7321 39.3109 25.2168H18.2607V39.9233Z"
        fill="#D80027"
      />
      <path
        d="M39.3109 14.7826C37.0159 6.26727 29.2404 0 19.9999 0C19.4138 0 18.834 0.0267187 18.2607 0.0760937V14.7826H39.3109Z"
        fill="#D80027"
      />
      <path
        d="M7.82607 4.13184C4.39662 6.76699 1.84615 10.4883 0.688965 14.782H7.82607V4.13184Z"
        fill="#D80027"
      />
      <path
        d="M39.8307 17.3915H15.6523H15.6522V0.475586C13.8039 0.88543 12.0516 1.54973 10.4348 2.43199V17.3914H0.169297C0.058125 18.2454 0 19.1161 0 20.0002C0 20.8843 0.058125 21.755 0.169297 22.6089H10.4347H10.4348V37.5683C12.0516 38.4505 13.8039 39.115 15.6522 39.5247V22.6091V22.6089H39.8307C39.9419 21.755 40 20.8843 40 20.0002C40 19.1161 39.9419 18.2454 39.8307 17.3915Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112097">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default OrkneyIslandsSvg;
